
import React, { useEffect, useState, useRef, createRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import TituloComponent from '../../components/Titulo/TituloComponent';
import Carregando from '../../components/Carregando/Carregando';
import { buscarFichasPagas, enviarFichas } from '../../services/api';
// cookies
import Cookies from 'js-cookie';


// css
import '../../styles/global.css';
import './MinhasFichasPagas.css';

/* eslint-disable no-restricted-globals */

const MinhasFichasPagas = () => {

    const navigate = useNavigate();

    const [fichas, setFichas] = useState([]);
    const [fichasUsar, setFichasUsar] = useState([]);
    const [carregando, setCarregando] = useState(true);

    // buscar as fichas periodicamente
    const [intervalId, setIntervalId] = useState(null);

    // vamos pegar o dadosCheckin dos cookies
    const dadosCheckin = JSON.parse(Cookies.get('dadosCheckin')) || {};
    const cpfClienteCheckin = dadosCheckin.numeroCpf;
    const nomeCliente = dadosCheckin.nome;
    const nomeEstabelecimento = dadosCheckin.estabelecimento.nome;

    useEffect(() => {
        console.log('----- ENTROU NO MinhasFichasPagas -----');

        console.log('cpf do cliente: ');
        console.log(cpfClienteCheckin);

        // vamos chamar o método que carrega os dados
        loadData();

    }, []);


    useEffect(() => {
        const id = setInterval(fetchFichas, 10000); // 30 segundos
        setIntervalId(id);
        return () => clearInterval(id);
    }, []);
    
    // método que pega a localização e busca os estabelecimentos
    const loadData = async () => {
        console.log(' *** Entrou no loadData ***');
        console.log('Dados do checkin: ');
        console.log(dadosCheckin);
        try {
            await fetchFichas(); 
        } catch (err) {
            console.log("Erro ao buscar as fichas:", err);
        }
    };


  // buscar todos os produtos do estabelecimento, para checkar os que já tem
  const fetchFichas = async () => {
    console.log('Entrou em fetchFichas em MinhasFichasPagas');

    try {
      const dados = await buscarFichasPagas(dadosCheckin);

      console.log('*** fichas ***', dados.fichas);

      if (dados?.fichas) {
        console.log('-> Fichas: ', dados.fichas);
        setFichas(dados.fichas);
        setCarregando(false);
      }
    } catch (error) {
      console.error('Erro ao buscar fichas:', error);
    }
  };

  // Função para usar a ficha - enviá-la para o bar ou cozinha
  const handleEnviarFichas = async () => {
    console.log('Entrou em handleEnviarFichas');
  
    if (fichasUsar.length === 0) {
      console.log('Nenhuma ficha selecionada');
      return;
    }
  
    try {
      await enviarFichas(fichasUsar);
      console.log('Fichas enviadas com sucesso');
      setFichasUsar([]); // Limpa o array de fichas usar após o envio
      alert('Fichas enviadas com sucesso!');

    } catch (error) {
      console.error('Erro ao enviar fichas:', error);
    }
  };

  const handleCheckboxChange = (ficha) => {
    const fichasUsarAtualizadas = [...fichasUsar];
    const indexFicha = fichasUsarAtualizadas.findIndex((f) => f.produto_pedido_id === ficha.produto_pedido_id);
  
    if (indexFicha !== -1) {
      // Se a ficha já está no array, remove-a
      fichasUsarAtualizadas.splice(indexFicha, 1);
    } else {
      // Se a ficha não está no array, adiciona-a
      fichasUsarAtualizadas.push(ficha);
    }
  
    setFichasUsar(fichasUsarAtualizadas);

    console.log('Fichas usar:');
    console.log(fichasUsarAtualizadas);
  };
  

  if (carregando) {
    return <Carregando />;
  }

  return (
    <div autoFocus className="fichas-container">
      <TituloComponent />

      <h1 className="sub-titulo">Fichas prontas pra uso</h1>
      
      <div className="box-dados">
        {
          nomeCliente
          ?
          <p className="texto-welcome">{nomeCliente},</p>
          :
          <></>
        }
        
        <p className="texto-welcome">Bem-vindo ao {nomeEstabelecimento}!</p>
      </div>

      {/* Container de quadros */}
      {fichas.map((ficha, index) => (

          console.log('(pedido) ficha = ', ficha),

          <div
            key={ficha.produto_pedido_id}  
            data-index={index} // O índice para o swipeHandler identificar
            data-id={ficha.produto_pedido_id} // O ID da ficha
            className="box-dados-ficha"
          >

          <p className="texto-ficha-numero">{ficha.produto_pedido_id}</p>
          <p className="texto-ficha-nome-produto">{ficha.nome_produto}</p>
          <p className="texto-ficha-preco">R$ {ficha.preco}</p>
          {/* <p>Quantidade: {ficha.quantidade}</p>
          <p>Cliente: {ficha.nome_do_cliente}</p>
          <p>Mesa: {ficha.numero_mesa} - Comanda: {ficha.numero_comanda}</p>
          <p>Data: {ficha.data_pedido} - {ficha.hora_pedido}</p>
          <p>Status: {ficha.status_pedido}</p> */}

          <div className="checkbox-container">
            <input 
              type="checkbox" 
              checked={fichasUsar.some((f) => f.produto_pedido_id === ficha.produto_pedido_id)} 
              onChange={() => handleCheckboxChange(ficha)} 
            /> 
            <p className="texto-ficha-usar">Usar essa ficha</p>
            {/* <p className="texto-ficha-usar">{ ficha.status_pedido }</p> */}
          </div>

        </div>
      ))}

      {/* Botão de usar ficha */}
      {
        fichas.length > 0
        ?
          <button className="welcome-btn" onClick={handleEnviarFichas}>Enviar Fichas</button>
        :
          <p className="texto-ficha-usar">Você não tem fichas pagas</p>
      }
      

    </div>
  );
};

export default MinhasFichasPagas;
